/** Filtro básico de moderación para chat in-app (Play Store / IARC). */
const BLOCKED_PATTERNS = [
  /\b(put[oa]s?|mierda|pendej[oa]s?|hij[oa]s?\s*de\s*puta|maric[oa]s?|gonorrea|malparid[oa]s?)\b/i,
  /\b(fuck|shit|bitch|asshole|nigger|faggot)\b/i,
];

export function moderateChatMessage(text) {
  const trimmed = (text || '').trim();
  if (!trimmed) {
    return { allowed: false, reason: 'empty' };
  }
  if (trimmed.length > 1000) {
    return { allowed: false, reason: 'too_long' };
  }
  for (const pattern of BLOCKED_PATTERNS) {
    if (pattern.test(trimmed)) {
      return { allowed: false, reason: 'moderated' };
    }
  }
  return { allowed: true };
}
